import React, { useEffect, useState } from "react";
import moment from "moment";
import BlogComponent from "../../components/blog/BlogComponent";
import Loading from "../../../components/isLoading";
import { fetchBlogData } from "../../../redux/blogs/index";
import { Edit, Publish, DeleteForever } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import DeleteModel from "../DeleteModel";
import ConfirmModel from "../ConfirmModel";
import { DELETE_BLOG } from "../../../redux/blogs/types";

const BlogContainer = (props) => {
  const { id } = props;
  const [state, setState] = useState({
    openDeleteMessage: false,
    openConfirmation: false,
  });
  const blogData = useSelector((state) => state.blogGlobalStore);
  const deleteStore = useSelector((store) => store.deleteBlogGlobalStore);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(fetchBlogData(id));
    }
  }, []);

  const handleOnEdit = () => navigate("edit");

  const handleOpenCloseConfirmModel = (condition) =>
    setState((prevState) => ({ ...prevState, openConfirmation: condition }));

  const handleOpenCloseDeleteModel = (condition) =>
    setState((prevState) => ({ ...prevState, openDeleteMessage: condition }));

  const isUnpublish = blogData.data?.status === "published";
  const crumps = [
    {
      title: "Blogs",
      path: "/blogs-stories",
    },
  ];
  const actions = [
    {
      onClick: handleOnEdit,
      text: "Edit Blog",
      icon: <Edit fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseConfirmModel(true),
      text: isUnpublish ? "Unpublish Blog" : "Publish Blog",
      icon: <Publish fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseDeleteModel(true),
      text: "Delete Blog",
      icon: <DeleteForever fontSize="small" />,
    },
  ];

  return blogData.loading ? (
    <Loading />
  ) : (
    <div>
      <DeleteModel
        isOpen={state.openDeleteMessage}
        isFor="Blogs"
        handleCloseModel={() => handleOpenCloseDeleteModel(false)}
        itemId={id}
        store={deleteStore}
        action={DELETE_BLOG}
      />
      <ConfirmModel
        isOpen={state.openConfirmation}
        isFor="Blogs"
        handleCloseModel={handleOpenCloseConfirmModel}
        itemId={id}
        isUnpublish={isUnpublish}
      />
      <BlogComponent
        blog={blogData.data || {}}
        crumps={crumps}
        actions={actions}
      />
    </div>
  );
};

export default BlogContainer;
